import { hooks as helmet$hooks } from ":src/contexts/helmet/SHARED/store";

export default {
  helmet: helmet$hooks,
};
